export const EQUIPMENT_LIST = '/admin/equipments/list'
